import constants from "./constants";

export const theme = {
  button: {
    backgroundColor: "#d4ba7e",
    color: "#252525",
  },
  logo: {
    backgroundColor: "unset",
  },
  colorOpposite: "#ffffff",
  floatingMenu: {
    minWidth: "340px",
  },
  fontFamily: "'Open Sans', sans-serif",
  hover: {
    color: "#ffffff",
    fill: "#ffffff",
  },
  menu: {
    backgroundColor: "#252525",
  },
  svg: {
    fill: "#999999",
    con: {
      fill: "white",
    },
  },
  [constants.DEVICE_TYPE.MOBILE]: {
    [constants.RESOLUTION.XXS]: {
      border: "none",
    },
    [constants.RESOLUTION.XS]: {
      border: "1px solid",
    },
    [constants.RESOLUTION.SM]: {
      border: "1px solid",
    },
    code: {
      borderRadius: "5px",
      color: "rgb(255,255,255,0.5)",
    },
    datePicker: {
      color: "#000",
      borderWidth: "1px",
      borderColor: "#e1e1e1",
      border: "1px solid #e1e1e1",
      borderRadius: "5px",
    },
    filter: {
      borderBottomWidth: "1px",
      borderTopWidth: "1px",
      borderRightWidth: "1px",
      borderLeftWidth: "1px",
      borderColor: "#e1e1e1",
      borderRadius: "5px",
      color: "#000",
      hover: {
        color: "#e1e1e1",
        fill: "unset",
      },
    },
    fontSize: "12px",
    svg: {
      fill: "#7e7e7e",
    },
  },
  [constants.DEVICE_TYPE.DESKTOP]: {
    code: {
      borderRadius: "0",
      color: "rgb(255,255,255,0.5)",
    },
    datePicker: {
      color: "#fff",
      borderBottom: "1px solid rgb(255,255,255,0.5)",
      borderRadius: "0",
    },
    filter: {
      borderBottomWidth: "1px",
      borderTopWidth: "0",
      borderRightWidth: "0",
      borderLeftWidth: "0",
      borderColor: "rgb(255,255,255,0.5)",
      borderRadius: "0px",
      color: "#fff",
      hover: {
        color: "#ffffff",
        fill: "#ffffff",
      },
    },
    fontSize: "13px",
    occupant: {
      color: "#fff",
      borderBottom: "1px solid rgb(255,255,255,0.5)",
    },
    svg: {
      fill: "rgb(255,255,255,0.5)",
    },
  },
};
